import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VoMenyyElement = _resolveComponent("VoMenyyElement")!
  const _component_KasutajaInfo = _resolveComponent("KasutajaInfo")!
  const _component_VoMenyy = _resolveComponent("VoMenyy")!

  return (_openBlock(), _createBlock(_component_VoMenyy, null, {
    elemendid: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
          (item.route && !item.condition || (item.condition && item.condition()))
            ? (_openBlock(), _createBlock(_component_VoMenyyElement, {
                key: 0,
                pealkiri: item.title,
                vaartus: item.value,
                keelatud: !item.route,
                ikoon: item.icon,
                url: item.route
              }, null, 8, ["pealkiri", "vaartus", "keelatud", "ikoon", "url"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    kasutaja: _withCtx(() => [
      _createVNode(_component_KasutajaInfo)
    ]),
    _: 1
  }))
}